import { render, staticRenderFns } from "./observatorioDelitosM.vue?vue&type=template&id=dee5fdbe"
import script from "./observatorioDelitosM.vue?vue&type=script&lang=js"
export * from "./observatorioDelitosM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports